
import { Component, OnInit, ViewChild, ViewEncapsulation, EventEmitter, Output, ChangeDetectorRef, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { NavigationService } from '../../../shared/services/navigation.service';
import { LanguageService } from '../../../services/language.service';
declare var $: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit {
  public username = '';
  public userRole = '';
  public avatarUrl = '';
  public isUserMenuOpen: boolean = false;
  public isLanguageMenuOpen: boolean = false;
  public currentLanguage = 'vi';
  
  private languages = [
    {
      code: 'vi',
      name: 'Tiếng Việt',
      flag: 'https://flagcdn.com/24x18/vn.png'
    },
    {
      code: 'en',
      name: 'English',
      flag: 'https://flagcdn.com/24x18/us.png'
    },
    {
      code: 'zh',
      name: '中文',
      flag: 'https://flagcdn.com/24x18/cn.png'
    },
    {
      code: 'fr',
      name: 'Français',
      flag: 'https://flagcdn.com/24x18/fr.png'
    }
  ];
  
  constructor(
    private dialog: MatDialog, 
    private router: Router, 
    private route: ActivatedRoute,
    public cd: ChangeDetectorRef, 
    private navigateBack: NavigationService,
    private languageService: LanguageService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    $.getScript('assets/js/navbar-menu.js');
    
    
    this.languageService.currentLanguage$.subscribe(lang => {
      this.currentLanguage = lang || 'vi';
      this.cd.detectChanges();
    });

    
    try {
      const userString = localStorage.getItem('user');
      if (userString) {
        const user = JSON.parse(userString);
        this.username = user.fullname || user.username || 'Admin User';
        
        if (user.roles && user.roles.length > 0) {
          const primaryRole = user.roles[0];
          this.userRole = this.formatRole(primaryRole.name);
        } else {
          this.userRole = 'Administrator';
        }
        
        const avatarName = encodeURIComponent(this.username);
        this.avatarUrl = `https://ui-avatars.com/api/?name=${avatarName}&background=3B82F6&color=fff`;
      } else {
        this.username = 'Admin User';
        this.userRole = 'Administrator';
        this.avatarUrl = 'https://ui-avatars.com/api/?name=Admin+User&background=3B82F6&color=fff';
      }
    } catch (e) {
      console.error('Lỗi khi parse user từ localStorage:', e);
      this.username = 'Admin User';
      this.userRole = 'Administrator';
      this.avatarUrl = 'https://ui-avatars.com/api/?name=Admin+User&background=3B82F6&color=fff';
    }
  }
  
  formatRole(role: string): string {
    if (!role) return 'Administrator';
    
    switch(role.toLowerCase()) {
      case 'owner':
        return 'Owner';
      case 'admin':
        return 'Administrator';
      case 'employee':
        return 'Nhân viên';
      default:
        return role;
    }
  }

  toggleUserMenu() {
    this.isUserMenuOpen = !this.isUserMenuOpen;
    if (this.isLanguageMenuOpen) {
      this.isLanguageMenuOpen = false;
    }
  }

  toggleLanguageMenu() {
    this.isLanguageMenuOpen = !this.isLanguageMenuOpen;
    if (this.isUserMenuOpen) {
      this.isUserMenuOpen = false;
    }
  }

  getCurrentLanguageFlag(): string {
    const currentLang = this.languages.find(lang => lang.code === this.currentLanguage);
    return currentLang ? currentLang.flag : 'https://flagcdn.com/24x18/vn.png';
  }

  getCurrentLanguageName(): string {
    const currentLang = this.languages.find(lang => lang.code === this.currentLanguage);
    return currentLang ? currentLang.name : 'Tiếng Việt';
  }

  switchLanguage(language: string) {
    this.isLanguageMenuOpen = false;
    this.languageService.switchLanguage(language);
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const userMenuElement = target.closest('.navbar-user');
    const languageMenuElement = target.closest('.language-switcher');
    
    if (!userMenuElement && this.isUserMenuOpen) {
      this.isUserMenuOpen = false;
      this.cd.detectChanges();
    }
    
    if (!languageMenuElement && this.isLanguageMenuOpen) {
      this.isLanguageMenuOpen = false;
      this.cd.detectChanges();
    }
  }

  logout() {
    localStorage.clear();
    this.languageService.resetToDefault();
    this.router.navigate(['/login']);
  }
}